import { gql } from '@apollo/client'

export default gql(`
query {
    listOptaSyncStates{
        items{
            id
            opId
            title
            lastRunTime
            frequency
            isRunning
            isActive
            isError
        }
    }
}`)
